{
	"backLinkTitle": "Înapoi la gestionarea declarațiilor",
	"invoicedQuantity": "Cantitate facturată",
	"remainingForDeclarationCreation": "Rămas pentru crearea declarației",
	"nonTransferableAmount": "Cantitate nealocabilă",
	"btnCreateDeclaration": "+ Creează declarație",
	"errorMessage": "Încărcarea detaliilor materialului a eșuat"
}
